"use client"

import { ProductCategory } from "@medusajs/medusa"
import { usePathname } from "next/navigation"
import { twMerge } from "tailwind-merge"

import TopBanner from "@modules/layout/components/top-banner"
import NavbarDesktop from "@modules/navigation/components/navbar-desktop"
import NavbarMobile from "@modules/navigation/components/navbar-mobile"

import { useScrollY } from "./useScrollY"

type NavbarProps = {
  categories: ProductCategory[]
  cartButton: JSX.Element
  rating: number
  showTopBanner: boolean
}

export default function Navbar(props: NavbarProps) {
  const { scrollY } = useScrollY()
  const pathname = usePathname()

  const isCategoryPage = pathname.includes("/categories")

  return (
    <div
      className={twMerge(
        "z-50 bg-white shadow-none transition-shadow sm:pb-4 lg:pb-0",
        isCategoryPage ? "" : scrollY !== 0 && "sticky top-0 shadow-2xl"
      )}
    >
      {props.showTopBanner && <TopBanner rating={props.rating} />}

      <header className="relative mx-auto h-16 bg-white text-black duration-200 md:h-20">
        <div className="lg:hidden">
          <NavbarMobile {...props} />
        </div>
        <div className="hidden lg:block">
          <NavbarDesktop {...props} />
        </div>
      </header>
    </div>
  )
}
